// Public controllers. Register editor/admin-only controllers in ../admin.js.
// Keep this list curated: stimulus:manifest:update would bundle every controller.

import { application } from "./application";

import AiActAssessmentController from "./ai_act_assessment_controller";
application.register("ai-act-assessment", AiActAssessmentController);

import CalEmbedController from "./cal_embed_controller";
application.register("cal-embed", CalEmbedController);

import CategoriesNavigationController from "./categories_navigation_controller";
application.register("categories-navigation", CategoriesNavigationController);

import ContactFormController from "./contact_form_controller";
application.register("contact-form", ContactFormController);

import CookieNoticeController from "./cookie_notice_controller";
application.register("cookie-notice", CookieNoticeController);

import DarkModeController from "./dark_mode_controller";
application.register("dark-mode", DarkModeController);

import FaqAccordionController from "./faq_accordion_controller";
application.register("faq-accordion", FaqAccordionController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import IframeAutosizeController from "./iframe_autosize_controller";
application.register("iframe-autosize", IframeAutosizeController);

import HeroNetworkController from "./hero_network_controller";
application.register("hero-network", HeroNetworkController);

import HeroTaglineController from "./hero_tagline_controller";
application.register("hero-tagline", HeroTaglineController);

import LazyBgController from "./lazy_bg_controller";
application.register("lazy-bg", LazyBgController);

import MobileNavigationController from "./mobile_navigation_controller";
application.register("mobile-navigation", MobileNavigationController);

import NewsletterController from "./newsletter_controller";
application.register("newsletter", NewsletterController);

import Soc2NewsletterSuccessController from "./soc2_newsletter_success_controller";
application.register("soc2-newsletter-success", Soc2NewsletterSuccessController);

import PolicyFormController from "./policy_form_controller";
application.register("policy-form", PolicyFormController);

import ProductScreenshotsController from "./product_screenshots_controller";
application.register("product-screenshots", ProductScreenshotsController);

import ReadingProgressController from "./reading_progress_controller";
application.register("reading-progress", ReadingProgressController);

import RevealController from "./reveal_controller";
application.register("reveal", RevealController);

import SyntaxHighlighController from "./syntax_highligh_controller";
application.register("syntax-highlight", SyntaxHighlighController);

import TabsController from "./tabs_controller";
application.register("tabs", TabsController);

import VideoModalController from "./video_modal_controller";
application.register("video-modal", VideoModalController);
